import React, { useState, useEffect } from "react";
import { Link, Redirect, Route, useHistory } from "react-router-dom";

import User from "../views/Admin/User";
import Organization from "../views/Admin/Organization";
import UserForm from "../views/Admin/UserForm";
import OrganizationFrom from "../views/Admin/OrganizationForm";
import ModelView from "../views/Admin/Model";
import OrganizationProfile from "../views/Admin/OrganizationProfile";
import UserProfile from "../views/Admin/UserProfile";

import Navbar from "../components/Navbars/Navbar";
import SideMenu from "../components/SideMenus/SideMenu";
import ModelForm from "../views/Admin/ModelForm";
import CustomModelForm from "../views/Admin/CustomModelForm";
import ModelEdit from "../views/Admin/ModelEdit";
import ModelUpload from "../views/Admin/ModelUpload";
import CloneModel from "../views/Admin/CloneModel";
// import Revenue from "../views/Admin/Revenue";
// import Subscription from "../views/Admin/Subscription";
// import InvoiceList from "../views/Admin/InvoiceList";
import LabStore from "../views/Admin/LabStore";
// import InvoiceDetails from "../views/Admin/InvoiceDetails";
import LabStoreProduct from "../views/Admin/LabStoreProduct";
import SimulateSamples from "../views/Admin/SimulateSamples";
import Measurements from "../views/Admin/Measurements";
import MaterialGroups from "../views/Admin/MaterialGroups";
import Lots from "../views/Admin/Lots";
import ContactSupport from "../views/Admin/ContactSupport";
import ActivityFeed from "../views/Admin/ActivityFeed";
import PublishedModels from "../views/Admin/PublishedModels";
import PublishModelForm from "../views/Admin/PublishModelForm";
import Coupons from "../views/Admin/Coupons";
import PublishBundleForm from "../views/Admin/PublishBundleForm";
import RevenueShareForm from "../views/Admin/RevenueShareForm";

import { ToastContainer } from "react-toastify";

import { LABSTORE_ACCESS, ROLES } from "../utils/constants";
import PrivateRoute from "../components/PrivateRoutes/PrivateRoute";
import ScansDetails from "../views/Admin/ScansDetails";

import Dashboard from "../views/Admin/Dashboard";
import ReviewProduct from "../views/Admin/ReviewProduct";
import Comments from "../views/Admin/Comments";
import { isAuthorized, isLabstoreAuthorized } from "../utils/RolesHelpers";
import NotFoundView from "../components/Shared/NotFoundView";
import ManageSecurity from "../views/Admin/ManageSecurity";
import PartnerProfile from "../views/Admin/PartnerProfile";
import DeviceManagement from "../views/Admin/DeviceManagement";
import MySubscriptions from "../views/Admin/MySubscriptions";
import Payments from "../views/Admin/Payments";
import PublishedProductVersions from "../views/Admin/PublishedProductVersions";
import { fetchLoggedUser } from "../utils/UserHelper";
import ModelParameterForm from "../views/Admin/ModelParameterForm";
import Footer from "../components/Footers/Footer";
import SubscribedProduct from "../views/Admin/SubscribedProduct";
import MaterialSuppliers from "../views/Admin/MaterialSuppliers";
import UnitsManagement from "../views/Admin/UnitsManagement";
import PromotionCodes from "../views/Admin/PromotionCodes";
import ClassifiersManagement from "../views/Admin/ClassifiersManagement";
import ScanFilters from "../components/Scans/ScanFilters";
import SimpleNotification from "../components/Notifications/SimpleNotification";
import { Trans } from "react-i18next";
import { addDateToDate, longDate } from "../utils/DateHelper";
import { t } from "i18next";
import Analytics from "../views/Admin/Analytics";
import MaterialSelection from "../components/Scans/materialSelection";
import Alerts from "../views/Admin/Alerts";
import AlertsForm from "../views/Admin/AlertsForm";

const Admin = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const history = useHistory();

    useEffect(() => {
        fetchLoggedUser(setCurrentUser);

        return () => {
            setCurrentUser(null);
        };
    }, []);

    useEffect(() => {
        if (currentUser && isAccessRestricted())
            history.push("/license-expired");
    }, [currentUser]);

    const getExtendedTimeEnd = () => {
        const endOfLicense = currentUser?.organization?.endOfLicense;
        const extendedDeadline = addDateToDate(new Date(endOfLicense), 30);

        return { date: longDate(extendedDeadline) };
    };

    const isAccessRestricted = () => {
        const userOrganization = currentUser?.organization;
        return (
            !userOrganization?.isLicenseValid &&
            !userOrganization?.isLicenseInExtendedPeriod &&
            !currentUser.role === ROLES.superAdmin
        );
    };

    const isExtendedPeriodValid = () => {
        const userOrganization = currentUser?.organization;
        return (
            !userOrganization?.isLicenseValid &&
            userOrganization?.isLicenseInExtendedPeriod
        );
    };

    const getExtendedMessage = () => {
        if (
            isAuthorized(
                [ROLES.support, ROLES.partnerAdmin],
                [currentUser.role]
            )
        ) {
            return (
                <Link className="underline text-blue-600" to="/license-expired">
                    {t("renewNow")}
                </Link>
            );
        }

        return t("contactAdmin");
    };

    if (!currentUser) return <></>;
    return (
        <>
            <Navbar currentUser={currentUser} />
            <SideMenu currentUser={currentUser} />

            <div className="license-notification pt-16 w-full">
                {isExtendedPeriodValid() && (
                    <SimpleNotification
                        message={
                            <>
                                <Trans i18nKey="licenseExpiredNotification">
                                    License expired must renew before
                                    {getExtendedTimeEnd()}
                                </Trans>
                                {getExtendedMessage()}
                            </>
                        }
                        className="m-0 flex justify-center py-2 px-4 pl-8 w-full"
                    />
                )}
            </div>
            {/* Main Content */}
            <main className="main-content expired-license" id="main-content">
                <Route path="/dashboard" exact component={Dashboard} />
                <Route path="/analytics" exact component={Analytics} />
                <Route
                    path="/manage-security"
                    exact
                    component={ManageSecurity}
                />
                <PrivateRoute
                    path="/users/form"
                    component={UserForm}
                    allowedRoles={[
                        ROLES.admin,
                        ROLES.partnerAdmin,
                        ROLES.superAdmin,
                        ROLES.support,
                    ]}
                />
                <PrivateRoute
                    path="/users"
                    exact
                    component={User}
                    allowedRoles={[
                        ROLES.admin,
                        ROLES.partnerAdmin,
                        ROLES.superAdmin,
                        ROLES.support,
                    ]}
                />
                <PrivateRoute
                    path="/affiliates/form"
                    component={OrganizationFrom}
                    allowedRoles={[
                        ROLES.partnerAdmin,
                        ROLES.superAdmin,
                        ROLES.support,
                    ]}
                />
                <PrivateRoute
                    path="/affiliates"
                    exact
                    component={Organization}
                    allowedRoles={[
                        ROLES.partnerAdmin,
                        ROLES.superAdmin,
                        ROLES.support,
                    ]}
                />
                <PrivateRoute
                    path="/models/create"
                    exact
                    component={ModelForm}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                />
                <PrivateRoute
                    path="/models/create/custom"
                    component={CustomModelForm}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                />
                <Route path="/models/view/:name" component={ModelEdit} />
                <PrivateRoute
                    path="/models/upload"
                    component={ModelUpload}
                    allowedRoles={[
                        ROLES.superAdmin,
                        ROLES.support,
                        ROLES.partnerAdmin,
                    ]}
                />
                <PrivateRoute
                    path="/models/edit"
                    component={ModelUpload}
                    allowedRoles={[
                        ROLES.superAdmin,
                        ROLES.support,
                        ROLES.partnerAdmin,
                    ]}
                />
                <PrivateRoute
                    path="/models/clone"
                    component={CloneModel}
                    allowedRoles={[ROLES.superAdmin]}
                />
                <PrivateRoute
                    path="/published-products/create"
                    component={PublishModelForm}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                    forbidden={
                        !isLabstoreAuthorized(
                            currentUser,
                            LABSTORE_ACCESS.publish
                        )
                    }
                />
                <PrivateRoute
                    exact
                    path="/published-products"
                    component={PublishedModels}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                    forbidden={
                        !isLabstoreAuthorized(
                            currentUser,
                            LABSTORE_ACCESS.publish
                        )
                    }
                />
                <PrivateRoute
                    path="/product/review"
                    component={ReviewProduct}
                    allowedRoles={[ROLES.support]}
                />
                <PrivateRoute
                    path="/products/share"
                    component={RevenueShareForm}
                    allowedRoles={[ROLES.support]}
                />
                <Route
                    exact
                    path="/models"
                    component={(props) => (
                        <ModelView {...props} currentUser={currentUser} />
                    )}
                />
                <Route
                    exact
                    path="/subscribed-products"
                    component={SubscribedProduct}
                />
                <Route path="/scans/filters" exact component={ScanFilters} />
                <Route path="/scans/details" exact component={ScansDetails} />
                <Route path="/scans" exact component={MaterialSelection} />
                <Route path="/settings" component={SimulateSamples} />
                <PrivateRoute
                    path="/my-subscriptions"
                    exact
                    component={MySubscriptions}
                    allowedRoles={[ROLES.support, ROLES.partnerAdmin]}
                />
                {/* <Route
                                path="/revenue"
                                exact
                                component={Revenue}
                            />
                            <Route
                                path="/Invoices"
                                exact
                                component={InvoiceList}
                            />
                            <Route
                                path="/Subscriptions"
                                exact
                                component={Subscription}
                            />

                            <Route
                                path="/Invoices/:id"
                                exact
                                component={InvoiceDetails}
                            />*/}
                <PrivateRoute
                    path="/store"
                    exact
                    component={LabStore}
                    forbidden={!isLabstoreAuthorized(currentUser)}
                    allowedRoles={[ROLES.support, ROLES.partnerAdmin]}
                />
                <PrivateRoute
                    path="/store/product/:id"
                    exact
                    component={LabStoreProduct}
                    forbidden={!isLabstoreAuthorized(currentUser)}
                />
                <PrivateRoute
                    path="/affiliate-profile"
                    component={OrganizationProfile}
                    allowedRoles={[
                        ROLES.partnerAdmin,
                        ROLES.support,
                        ROLES.admin,
                    ]}
                />
                <Route
                    path="/partners/profile/:name"
                    component={PartnerProfile}
                />
                <Route path="/profile" component={UserProfile} />
                <PrivateRoute
                    path="/measurements"
                    component={Measurements}
                    allowedRoles={[
                        ROLES.superAdmin,
                        ROLES.partnerAdmin,
                        ROLES.partnerUser,
                        ROLES.admin,
                        ROLES.support,
                    ]}
                />
                <PrivateRoute
                    exact
                    path="/options/alerts"
                    component={Alerts}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                />
                <PrivateRoute
                    path="/options/alerts/create"
                    component={AlertsForm}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                />
                <Route
                    path="/options/material-groups"
                    component={MaterialGroups}
                />
                <PrivateRoute
                    path="/options/materials-suppliers"
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                    component={MaterialSuppliers}
                    forbidden={!currentUser?.organization?.suppliersAccess}
                />
                <PrivateRoute
                    path="/options/units-management"
                    allowedRoles={[ROLES.superAdmin]}
                    component={UnitsManagement}
                />
                <Route path="/options/lots" component={Lots} />
                <PrivateRoute
                    path="/options/device-management"
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                    component={DeviceManagement}
                />
                <PrivateRoute
                    path="/options/classifiers-management"
                    allowedRoles={[ROLES.support]}
                    component={ClassifiersManagement}
                />

                <Route path="/support" component={ContactSupport} />
                <PrivateRoute
                    path="/options/activity-feed"
                    component={ActivityFeed}
                    allowedRoles={[ROLES.superAdmin, ROLES.support]}
                />

                <PrivateRoute
                    path="/coupons"
                    component={Coupons}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                />
                <PrivateRoute
                    path="/publish-bundle"
                    component={PublishBundleForm}
                    allowedRoles={[ROLES.support, ROLES.partnerAdmin]}
                    forbidden={
                        !isLabstoreAuthorized(
                            currentUser,
                            LABSTORE_ACCESS.publish
                        ) && !currentUser?.organization?.createBundleAccess
                    }
                />
                <PrivateRoute
                    path="/models/parameter/create"
                    component={ModelParameterForm}
                    allowedRoles={[ROLES.support, ROLES.partnerAdmin]}
                />
                <PrivateRoute
                    path="/promotion-codes"
                    component={PromotionCodes}
                    allowedRoles={[
                        ROLES.support,
                        ROLES.partnerAdmin,
                        ROLES.superAdmin,
                    ]}
                />
                <PrivateRoute
                    exact
                    path="/product/version/create"
                    component={({ location }) => {
                        return location.state?.isBundle ? (
                            <PublishBundleForm />
                        ) : (
                            <PublishModelForm />
                        );
                    }}
                    allowedRoles={[ROLES.partnerAdmin, ROLES.support]}
                    forbidden={
                        !isLabstoreAuthorized(
                            currentUser,
                            LABSTORE_ACCESS.publish
                        )
                    }
                />

                <PrivateRoute
                    exact
                    path="/product/version/update/:productVersionId"
                    component={({ location }) => {
                        return location.state?.isBundle ? (
                            <PublishBundleForm isUpdate={true} />
                        ) : (
                            <PublishModelForm isUpdate={true} />
                        );
                    }}
                    allowedRoles={[ROLES.support, ROLES.partnerAdmin]}
                    forbidden={
                        !isLabstoreAuthorized(
                            currentUser,
                            LABSTORE_ACCESS.publish
                        )
                    }
                />
                <PrivateRoute
                    path="/product/version/list/:id"
                    component={PublishedProductVersions}
                    allowedRoles={[ROLES.support, ROLES.partnerAdmin]}
                    forbidden={
                        !isLabstoreAuthorized(
                            currentUser,
                            LABSTORE_ACCESS.publish
                        )
                    }
                />
                <Route path="/payments" exact component={Payments} />
                <Route path="/page-not-found" component={NotFoundView} />
                <Route path="/comments" component={Comments} />
                <Route exact path="/">
                    <Redirect to="/dashboard" />
                </Route>

                {/* <Redirect from="*" to="/page-not-found" /> */}
            </main>
            <Footer />

            <ToastContainer limit={3} />
        </>
    );
};

export default Admin;
